import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import RegisterButton from '../../components/atoms/RegisterButton';
import { getAccounts } from '../../actions/Accounts';
import { generateCode } from '../../actions/GenerateCode';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  }
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      prefectures: state.commons.prefectures,
      shopCategories: state.commons.shopCategories
    }),
    dispatch => ({
      actions: bindActionCreators({ getAccounts, generateCode }, dispatch)
    })
  ),
  withState('eventId', 'setEventId', null),
  withState('totalCode', 'setTotalCode', null),
  withState('menuId', 'setMenuId', null),
  withState('error', 'setError', null),
  withState('send', 'setSend', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
      });
    }
  })
);

const Main = enhance(
  ({
    actions,
    error,
    setError,
    eventId,
    setEventId,
    totalCode,
    setTotalCode,
    menuId,
    setMenuId,
    send,
    setSend
  }) => {
    const generateCodeAction = async (totalC, mId, eId) => {
      const params = {
        totalCode: parseInt(totalC, 10),
        menuId: parseInt(mId, 10),
        eventId: parseInt(eId, 10)
      };
      const genCode = await actions.generateCode(params);
      if (genCode.type === 'GENERATE_CODE_SUCCESS') {
        alert('Generate Code Success!');
      } else {
        alert('Generate Code Fail!');
      }
      setSend(false);
    };

    const create = () => {
      setSend(true);
      if (!totalCode || !menuId || !eventId) {
        setError('input not empty');
      } else {
        generateCodeAction(totalCode, menuId, eventId);
        setError('');
      }
    };

    return (
      <div className="box-create">
        <h2>Tool Generate Code</h2>
        <br />
        <br />
        <p>Input</p>
        <p>Total Code</p>
        <input
          className="group"
          type="text"
          name="totalCode"
          onChange={e => {
            setTotalCode(e.target.value);
          }}
        />
        <p>Menu Id</p>
        <input
          className="group"
          type="text"
          name="menuId"
          onChange={e => {
            setMenuId(e.target.value);
          }}
        />
        <p>Event Id</p>
        <input
          className="group"
          type="text"
          name="eventId"
          onChange={e => {
            setEventId(e.target.value);
          }}
        />
        {error && <p>{error}</p>}
        <br />
        <RegisterButton onClickAction={create} disabled={send} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
